module.exports = __webpack_public_path__ + "assets/img/back-899e9229.png";